import { ScholarshipPaymentDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipPaymentService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getScholarshipPayment(id): Observable<ScholarshipPaymentDto[]> {
    console.log('id ', id);
    return this.http.get<ScholarshipPaymentDto[]>(
      this.url + 'scholarship-payment/all/' + id
    );
  }

  createScholarshipPayment(
    data: ScholarshipPaymentDto
  ): Observable<ScholarshipPaymentDto> {
    return this.http.post<ScholarshipPaymentDto>(
      this.url + 'scholarship-payment',
      data
    );
  }

  getSingleScholarshipPayment(id: string): Observable<any> {
    return this.http.get(this.url + 'scholarship-payment/' + id);
  }

  updateScholarshipPayment(
    data: ScholarshipPaymentDto
  ): Observable<ScholarshipPaymentDto> {
    return this.http.post<ScholarshipPaymentDto>(
      this.url + 'scholarship-payment/update',
      data
    );
  }

  deleteScholarshipPayment(id: any) {
    return this.http.delete(this.url + 'scholarship-payment/' + id);
  }
}
